var GridArrangerOptions          = require("app/ui/repeaters/GridArrangerOptions"),
    IconButton                   = require("app/ui/IconButton"),
    NoBookmarksView              = require("./NoBookmarksView"),
    PrefixedVirtualizedRepeater  = require("app/ui/repeaters/PrefixedVirtualizedRepeater"),
    RepeaterArrayDiffDataAdapter = require("enyo-ui/RepeaterArrayDiffDataAdapter"),
    RepeaterPaddedGridArranger   = require("enyo-ui/RepeaterPaddedGridArranger"),
    ScrollAnchorMemorySupport    = require("app/ui/ScrollAnchorMemorySupport"),
    ScrollerDecoratorScrollbars  = require("app/ui/ScrollerDecoratorScrollbars"),
    ThumbnailPlaceholder         = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    frameThrottle                = require("enyo-perf/utils").frameThrottle,
    get                          = require("object-path").get,
    icons                        = require("app/theme/icons"),
    kind                         = require("enyo/kind"),
    resolveBookmarkThumbnailKind = require("app/utils/resolveBookmarkThumbnailKind"),
    themeVars                    = require("app/theme/variables"),
    utils                        = require("enyo/utils");

require("./PageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.BookmarkPage.GridPageView.prototype */ {

    /**
     * @private
     */
    name: "app.BookmarkPage.GridPageView",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    classes: "app-bookmark-page-page-view",

    /**
     * @private
     */
    fit: true,

    /**
     * @private
     */
    bookmarkMode: "link",

    /**
     * @public
     */
    scrollerPath: ".$.bookmarks.$.scroller",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * Default scroll-bars theme for desktop, minimal for mobile.
     *
     * @public
     */
    theme: "page",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:            "bookmarks",
        kind:            PrefixedVirtualizedRepeater,
        mixins:          [ScrollAnchorMemorySupport],
        classes:         "app-bookmark-page-page-view__bookmarks",
        showTitles:      true,
        showPlayIcons:   true,
        showInfoLinks:   true,
        showDeleteIcons: true,
        components:      [{
            name:       "grid-header",
            classes:    "app-bookmark-page-page-view__grid-header",
            components: [{
                name:    "title",
                tag:     "h2",
                classes: "app-bookmark-page-page-view__title"
            }, {
                name:          "editButton",
                kind:          IconButton,
                classes:       "app-bookmark-page-page-view__edit-button",
                icon:          icons["app.BookmarkPage.GridPageView.editButton"],
                iconAlignment: "right",
                ontap:         "onEditButtonTap"
            }]
        }, {
            name:    "noBookmarks",
            kind:    NoBookmarksView,
            classes: "app-bookmark-page-page-view__no-bookmarks"
        }],
        childFormFactor: "square",
        dataAdapterKind: kind({
            kind: RepeaterArrayDiffDataAdapter,

            /**
             * Gets a unique identifier for the record.
             *
             * @param  {*}       record  The record
             * @return {string}  The record uid.
             * @public
             */
            getRecordUid: function(record) {
                return String(record.media_id);
            }
        }),
        drawAsync:       true,
        scrollerOptions: {
            fit:            true,
            vertical:       true,
            horizontal:     false,
            scrollChaining: false
        },
        arrangerKind:    RepeaterPaddedGridArranger,
        arrangerOptions: utils.mixin(utils.clone(GridArrangerOptions), {

            /**
             * The amount of padding the bottom of the grid.
             *
             * @return {number}  The padding
             * @public
             */
            padBottom: function() {
                return themeVars.getContentPaddingVerticalPx() * 3;
            }
        }),

        /**
         * The kind that will be rendered for each placeholder.
         *
         * @type {enyo.Control}
         * @public
         */
        placeholderKind: ThumbnailPlaceholder,

        /**
         * Optional extra options to merge into the placeholder kind at creation
         * time.
         *
         * @type {Object=}
         * @public
         */
        placeholderOptions: {
            bindings: [{
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor  Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }, {
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle  Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }]
        },

        /**
         * Return the right kind of row depending on the type of media.
         *
         * @param   {?string}       bookmark  The bookmark
         * @return  {enyo.Control}  The row kind
         * @public
         */
        getChildKind: resolveBookmarkThumbnailKind,

        /**
         * Optional extra options to merge into the child kind at creation time.
         *
         * @type {Object}
         * @public
         */
        childOptions: {
            bindings: [{
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor  Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }, {
                from: ".repeater.bookmarkMode",
                to:   ".mode",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  mode  Thumbnail mode (link | delete).
                 * @return  {string}   The desired thumbnail mode.
                 * @private
                 */
                transform: function(mode) {
                    if (mode === undefined) {
                        return this.get("mode");
                    }
                    else {
                        return mode;
                    }
                }
            }, {
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle  Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.showPlayIcons",
                to:   ".showPlayIcon",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showPlayIcon  Play icon visibility.
                 * @return  {boolean}   Whether to show the play icon.
                 * @private
                 */
                transform: function(showPlayIcon) {
                    if (showPlayIcon === undefined) {
                        return this.get("showPlayIcon");
                    }
                    else {
                        return showPlayIcon;
                    }
                }
            }, {
                from: ".repeater.showInfoLinks",
                to:   ".showInfoLink",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showInfoLink  Info icon visibility.
                 * @return  {boolean}   Whether to show the info icon.
                 * @private
                 */
                transform: function(showInfoLink) {
                    if (showInfoLink === undefined) {
                        return this.get("showInfoLink");
                    }
                    else {
                        return showInfoLink;
                    }
                }
            }, {
                from: ".repeater.showDeleteIcons",
                to:   ".showDeleteIcon",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showDeleteIcon  Delete icon visibility.
                 * @return  {boolean}   Whether to show the delete icon.
                 * @private
                 */
                transform: function(showDeleteIcon) {
                    if (showDeleteIcon === undefined) {
                        return this.get("showDeleteIcon");
                    }
                    else {
                        return showDeleteIcon;
                    }
                }
            }]
        }
    }],

    /**
     * @private
     */
    handlers: {
        onRequestDeleteBookmark: "onRequestDeleteBookmark"
    },

    /**
     * @private
     */
    bindings: [{
        from: ".bookmarkMode",
        to:   ".$.bookmarks.bookmarkMode"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state", "bookmarkMode"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService = this.app.$.i18nService,
            state        = this.state || {},
            numItems     = get(state, "bookmarks.length", 0),
            $editButton  = this.$.editButton,
            $bookmarks   = this.$.bookmarks,
            anchorKey    = "BookmarkPage/PageView";

        this.$.title.set("content", $i18nService.getString("app.BookmarkPage.title"));

        if (this.get("bookmarkMode") === "link") {
            $editButton.set("caption", $i18nService.getString("app.BookmarkPage.DeleteButton.inactive.caption"));
            $editButton.set("tooltip", $i18nService.getString("app.BookmarkPage.DeleteButton.inactive.tooltip"));
        }
        else {
            $editButton.set("caption", $i18nService.getString("app.BookmarkPage.DeleteButton.active.caption"));
            $editButton.set("tooltip", $i18nService.getString("app.BookmarkPage.DeleteButton.active.tooltip"));
        }

        $bookmarks.addRemoveClass("no-bookmarks", numItems === 0);
        $bookmarks.$.client.set("fit", numItems === 0);
        $bookmarks.set("data", get(state, "bookmarks", []));
        $bookmarks.set("anchorKey", anchorKey);

        anchorKey && $bookmarks.restoreAnchor();
    },

    /**
     * @private
     */
    onEditButtonTap: function() {
        if (this.get("bookmarkMode") === "link") {
            this.set("bookmarkMode", "delete");
        }
        else {
            this.set("bookmarkMode", "link");
        }
    },

    /**
     * Delete the bookmark.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onRequestDeleteBookmark: function(sender, event) {
        this.controller.onRequestDeleteBookmark(this, event);
    }

});
